const MessageTypes = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  NOTICE: 'notice',
  WISHLIST: 'wishlist',
});

export default MessageTypes;
